import Rollbar from 'rollbar';

import getRuntimeConfiguration from './getRuntimeConfiguration';
import { isNode } from './environment';

const accessToken = isNode() ?
  getRuntimeConfiguration('ROLLBAR_ACCESS_TOKEN_SERVER') :
  getRuntimeConfiguration('ROLLBAR_ACCESS_TOKEN_CLIENT');

const browserConfiguration = {
  hostSafeList: ['cloudfront.net', 'babbel.com', 'babbel.cn'],
};

const checkIgnore = (isUncaught, args, payload) => {
  if (!isUncaught) {
    // We want to track all errors we report ourselves
    return false;
  }
  const isPromiseRejection = args.some((arg) => arg instanceof Promise);
  if (isPromiseRejection) {
    // Promise rejections' stackframes can have no information even though
    // they are valid, so we default to reporting them all
    return false;
  }
  const { trace } = payload.body;
  const hasAtLeastOneRelevantFrame = trace.frames.some(({ filename, method }) => {
    if ('(unknown)' === filename) {
      return false;
    }
    let fileAsUrl;
    // Rollbar is often part of the stack frames as it's the one listenting to the error
    // so if a stack has only rollbar frames, we consider it irrelevant
    const isRollbarFrame = filename.includes('node_modules/rollbar');
    try {
      fileAsUrl = new URL(filename);
    } catch {
      // If the filename wasn't a URL, it was a relative path from the root of the project
      // in this case it's relevant except if it's a Rollbar frame
      return !isRollbarFrame;
    }
    const isDomainFrame = browserConfiguration.hostSafeList.includes(fileAsUrl.host);
    const isGlobalCode = 'global code' === method;
    return isDomainFrame && !isRollbarFrame && !isGlobalCode;
  });
  return !hasAtLeastOneRelevantFrame;
};

const rollbarConfig = {
  accessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  checkIgnore,
  payload: {
    client: {
      javascript: {
        // eslint-disable-next-line no-undef -- Replaced by webpack's DefinePlugin at build time
        code_version: BUILD_TIME_CONFIGURATION_COMMIT_SHA,
        guess_uncaught_frames: true,
        source_map_enabled: true,
      },
    },
    environment: getRuntimeConfiguration('ENVIRONMENT'),
    server: {
      root: 'webpack:///./',
    },
  },
  ...(isNode() ? {} : browserConfiguration),
};

const logger = accessToken ? new Rollbar(rollbarConfig) :
  ({
    configure: () => {},
    // eslint-disable-next-line no-console -- we need the consoles here as we are mimicking rollbar for local dev
    critical: console.error.bind(console),
    // eslint-disable-next-line no-console -- we need the consoles here as we are mimicking rollbar for local dev
    error: console.error.bind(console),
    // eslint-disable-next-line no-console -- we need the consoles here as we are mimicking rollbar for local dev
    warning: console.warn.bind(console),
    // eslint-disable-next-line no-console -- we need the consoles here as we are mimicking rollbar for local dev
    info: console.log.bind(console),
    // eslint-disable-next-line no-console -- we need the consoles here as we are mimicking rollbar for local dev
    debug: console.log.bind(console),
    lambdaHandler: (fn) => fn,
  });

export default logger;
